import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastMessageContext = createContext();

export const useToastMessage = () => {
  const context = useContext(ToastMessageContext);
  if (!context) {
    throw new Error('useToastMessage must be used within a ToastMessageProvider');
  }
  return context;
};

export const ToastMessageProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = 'info', duration = 3000) => {
    const id = Date.now() + Math.random();
    const toast = {
      id,
      message,
      type,
      duration
    };

    setToasts(prev => [...prev, toast]);

    // 자동 제거
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, duration);

    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  const clearAllToasts = useCallback(() => {
    setToasts([]);
  }, []);

  const value = {
    toasts,
    showToast,
    showToastMessage: showToast, // 이전 호환성을 위한 별칭
    removeToast,
    clearAllToasts,
    // 편의 메서드들
    showSuccess: (message, duration) => showToast(message, 'success', duration),
    showError: (message, duration) => showToast(message, 'error', duration),
    showWarning: (message, duration) => showToast(message, 'warning', duration),
    showInfo: (message, duration) => showToast(message, 'info', duration)
  };

  return (
    <ToastMessageContext.Provider value={value}>
      {children}
    </ToastMessageContext.Provider>
  );
};

export default ToastMessageContext;
